// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1n2ho","name":"ConsentHeader_name__3LH6C","birthday":"ConsentHeader_birthday__1jcpS","skeleton":"ConsentHeader_skeleton__3-xR3"};